import {css, StyleSheet} from 'aphrodite';
import React, {ReactNode} from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';

interface ParameterPillListProps {
  children: ReactNode;
}

export default function ParameterPillList(props: ParameterPillListProps): JSX.Element {
  return (
    <span
      className={css(styles.pillList)}
      {...getTestProps({component: 'ParameterPillList', element: 'root'})}
    >
      {props.children}
    </span>
  );
}

const styles = StyleSheet.create({
  pillList: {
    lineHeight: '36px',
    // For the first line of parameter pills, undo the 4px margin-top that line-height adds
    marginTop: -4,
  },
});
